import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ThemeSwitcher from "../components/ThemeSwitcher";
import { Pulse, ArrowRight, ArrowLeft } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@signaldesk.io");
  const [password, setPassword] = useState("signaldesk123");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="absolute top-4 right-4"><ThemeSwitcher /></div>
      <Link to="/" data-testid="back-home" className="absolute top-5 left-5 flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
        <ArrowLeft size={15} weight="bold" /> Public site
      </Link>

      <div className="w-full max-w-md glass-strong rounded-3xl p-8 fade-up">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-2xl brand-gradient flex items-center justify-center shadow-lg"><Pulse size={20} weight="bold" className="text-white" /></div>
          <div>
            <div className="font-display font-extrabold text-lg tracking-tight">Signal<span className="brand-text">Desk</span></div>
            <div className="text-[10px] tracking-[0.2em] text-muted-foreground uppercase">Configuration Access</div>
          </div>
        </div>

        <h1 className="font-display text-2xl font-bold tracking-tight">Welcome back</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">Sign in to configure integrations & manage the desk.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-muted-foreground mb-1.5">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-2xl bg-background/60 border border-border px-4 py-3 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition-all duration-200" />
          </div>
          <div>
            <label className="block text-xs font-medium text-muted-foreground mb-1.5">Password</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-2xl bg-background/60 border border-border px-4 py-3 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition-all duration-200" />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-bear bg-bear/10 border border-bear/30 rounded-2xl px-4 py-2.5">{error}</div>}
          <button data-testid="login-submit" disabled={loading}
            className="w-full brand-gradient text-white font-semibold rounded-2xl py-3 flex items-center justify-center gap-2 shadow-lg hover:opacity-90 disabled:opacity-60 transition-opacity duration-200">
            {loading ? "Signing in…" : <>Enter Desk <ArrowRight size={16} weight="bold" /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
